import React, {Component} from 'react'
import {render} from 'react-dom'

import props from './housing.json'

import {VaineWidget} from '../../'

const Demo = () => {
  return <div style={{"width":"100vw", "display":"flex", "flex-direction":"column", "align-items":"center"}}>
    <div>
      <h1 style={{"font-family":"sans-serif"}}>vaine-widget demo</h1>
      <p style={{"font-family":"sans-serif", "width":"840px", "margin-bottom": "50px"}}>
        VAINE -- Visualization and AI for Natural Experiments -- is a visual analytics system that 
        enables users to identify natural experiments in observational data and estimate the impact
        of treatment variables on outcomes. This is a web-demo version of the VAINE interface.
        For implementation details and usage scenarios, read our paper <a href="https://arxiv.org/abs/2109.04348">here</a>.
      </p>
      <VaineWidget {...props}/>
      <div style={{"font-family":"sans-serif", "margin-top": "25px"}}>
      Data Source: <a href='http://jse.amstat.org/v19n3/decock.pdf'>Ames Housing dataset</a>
      </div>
    </div>
  </div>
}

render(<Demo/>, document.querySelector('#demo'))



// WEBPACK FOOTER //
// ./demo/src/index.js